import { ChronoUnit, LocalDate, LocalTime } from '@js-joda/core';

export const getInitialEstimatedDuration = (startTime: LocalTime, endTime: LocalTime, date: LocalDate): number => {
   if (LocalTime.MIDNIGHT.equals(endTime)) {
      const startDate = date.atTime(startTime);
      return startDate.until(date.plusDays(1).atStartOfDay(), ChronoUnit.MINUTES);
   }

   return startTime.until(endTime, ChronoUnit.MINUTES);
};
